import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { customHeaders, adminAPIURL } from '../../../../../Containers/Config/index.js';
import { EMAIL_PHONE_DRAFT, EMAIL_PHONE_DRAFT_SUCCESS, EMAIL_PHONE_DRAFT_ERROR } from '../../actions.js';
import apiCall from '../../../apiCall.js';
import cogoToast from 'cogo-toast';

function* emailPhoneDraft({ payload }) {
  try {
    const filteredHeaders = { ...customHeaders };
    delete filteredHeaders['X-Requested-By'];

    const response = yield call(apiCall, {
      url: `${adminAPIURL}/v2/admin/profile/email-phone-draft`,
      method: 'POST',
      data: payload.data,
      // isFormData: true,
      headers: {
        ...filteredHeaders,
      },
    });

    if (response.status === 200) {
      cogoToast.success(`${response?.data?.message}`);

      yield put({
        type: EMAIL_PHONE_DRAFT_SUCCESS,
        payload: response?.data,
      });
    } else {
      cogoToast.error(`${response?.response?.data?.message}`);
      yield put({
        type: EMAIL_PHONE_DRAFT_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: EMAIL_PHONE_DRAFT_ERROR, payload: error });
  }
}

export function* watchEmailPhoneDraft() {
  yield takeEvery(EMAIL_PHONE_DRAFT, emailPhoneDraft);
}

function* emailPhoneDraftSaga() {
  yield all([fork(watchEmailPhoneDraft)]);
}

export default emailPhoneDraftSaga;
